import React, { useState, useEffect } from "react";
import { Form, Flex, Button, Col, Row, message, List, Select } from "antd";
import { PlusSquareOutlined, PlusOutlined } from "@ant-design/icons";
import EditSVG from "../../../assets/teamMember/EditSVG";
import DeleteSVG from "../../../assets/common/DeleteSVG";
import { editTeamMember } from "../../../network/teamMember";
import { queryKeys } from "../../../services/react-query/queryKeys";
import queryClient from "../../../services/react-query/queryClient";
import { useMutation, useQuery } from "@tanstack/react-query";
import ServiceSVG from "../../../assets/catalog/ServiceSVG";
import { Category } from "../../../types/category";
import { getAllCategories } from "../../../network/category";
import { listParentwithServices } from "../../../network/service";
import IconSVG from "../../../assets/teamMember/IconSVG";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { getAllPackagesWithCategories } from "../../../network/package";
import PackagesSVG from "../../../assets/catalog/PackagesSVG";
import { service } from "../../../types/service";
import SubInfo from "../../admin/common/SubInfo";

const ServiceInfo: React.FC<{ teamMemberData: any }> = ({ teamMemberData }) => {
  const intl = useIntl();
  const { currentLang } = useSelector(
    (state: { user: { currentLang: "en" | "ar" } }) => {
      return {
        currentLang: state.user.currentLang,
      };
    }
  );
  const [editing, setEditing] = useState(false);
  const [showServiceSelector, setShowServiceSelector] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [selectedServices, setSelectedServices] = useState<
    Array<{
      id: number;
      name: string;
    }>
  >(
    teamMemberData?.services?.map(
      (s: { id: number; name: { ar: string; en: string } }) => ({
        id: s.id,
        name: s.name[currentLang],
      })
    ) || []
  );

  const [selectedPackages, setSelectedPackages] = useState<
    Array<{
      id: number;
      name: string;
      retail_price: string;
      total_time: string;
    }>
  >(
    teamMemberData?.packages?.map(
      (p: {
        id: number;
        name: { ar: string; en: string };
        total_time: string;
        retail_price: string;
      }) => ({
        id: p.id,
        name: p.name[currentLang],
        retail_price: p.retail_price,
        total_time: p.total_time,
      })
    ) || []
  );

  const { locationId } = useSelector(
    (state: { calendar: { locationId: number } }) => state.calendar
  );

  const { data: packages } = useQuery(
    [queryKeys.listPackages, locationId],
    () => getAllPackagesWithCategories(locationId),
    {
      enabled: !!locationId,
      select: (res) => {
        const data: any[] = [];
        res?.data?.map((category: { services: any[]; packages: any[] }) => {
          if (category?.packages?.length > 0) {
            data.push(category);
          }
        });
        return data;
      },
    }
  );

  const packagesCategoriesOptions = Array.isArray(packages)
    ? packages?.map((category) => ({
        label: category?.name,
        value: category?.id,
        key: category?.id,
      }))
    : [];
  const [selectedPackageCategoryId, setSelectedPackageCategoryId] = useState<
    null | number
  >(null);
  const getPackagesOptions = () => {
    const categoryPackages = packages?.find(
      (pkg: {
        id: number;
        name: string;
        packages: Array<{
          name: string;
          id: number;
          total_time: string;
          retail_price: string;
        }>;
      }) => pkg?.id === selectedPackageCategoryId
    );

    if (categoryPackages) {
      return categoryPackages?.packages?.map(
        (packageItem: {
          name: string;
          id: number;
          total_time: string;
          retail_price: string;
        }) => ({
          label: <span className="capitalize"> {packageItem?.name}</span>,
          value: packageItem?.id,
          key: packageItem?.id,
          disabled: !!selectedPackages.find(
            (selectedPackage) => selectedPackage?.id === packageItem?.id
          ),
        })
      );
    } else {
      return [];
    }
  };
  const [form] = Form.useForm();
  const { data: listCategories } = useQuery(
    [queryKeys.listCategories, teamMemberData],
    () => {
      const params: any = {};
      for (let i = 0; i < teamMemberData?.locations?.length; i++) {
        params[`location_ids[${i}]`] = teamMemberData?.locations[i]?.id;
      }
      return getAllCategories(params);
    }
  );

  const { data: listServices } = useQuery(
    [queryKeys.listServices, selectedCategoryId],
    () =>
      listParentwithServices({
        category_id: selectedCategoryId,
      }),
    {
      enabled: !!selectedCategoryId,
    }
  );
  console.log(teamMemberData, "teamMemberData");
  const { mutate: editMutation, isLoading } = useMutation<
    void,
    unknown,
    { services: { service_id: number; pricing_option_id: number } }
  >((params) => editTeamMember(teamMemberData?.id, params), {
    onSuccess: (res: any) => {
      console.log(res, "res");
      if (res && res?.code !== "ERR_BAD_REQUEST") {
        queryClient.invalidateQueries([queryKeys.listSpacficTeamMemer]);
        setEditing(false);
        setShowServiceSelector(false);
      } else {
        message.error(
          res?.response?.data?.message ||
            intl.formatMessage({ id: "somethingWentWrong" })
        );
      }
    },
    onError: (error) => {
      message.error("حاول مرة اخرى");
    },
  });

  const handleAddLocationClick = () => {
    setShowServiceSelector(true);
  };

  const onFinish = async (values: any) => {
    values.services = selectedServices.map((service) => ({
      service_id: service?.id,
    }));
    values.package_ids = selectedPackages.map((pkg) => pkg?.id);

    editMutation(values);
  };
  const handleRemoveService = (serviceId: any) => {
    const newServices = selectedServices.filter(
      (item) => item.id !== serviceId
    );
    setSelectedServices(newServices);
  };
  return (
    <div className="tabs bg-[#EEF0FF] p-4">
      <Flex justify="flex-end">
        <Button
          onClick={() => {
            setEditing(!editing);
            setShowServiceSelector(!showServiceSelector);
            handleAddLocationClick();
          }}
          className="border-none bg-transparent shadow-none outline-none"
        >
          <EditSVG />
        </Button>
      </Flex>

      {!editing && (
        <div className="space-y-4">
          <div>
            <p>
              {" "}
              {intl.formatMessage({
                id: "servicesByMember",
              })}
            </p>
            {teamMemberData?.services?.map(
              (pkg: { id: number; name: { ar: string; en: string } }) => (
                <>
                  <div
                    key={pkg?.id}
                    className="flex px-2 gap-2 my-1 bg-white p-1 justify-between rounded"
                  >
                    <div className="flex items-center  w-full ">
                      <div className="flex gap-8 items-center justify-between w-full p-1">
                        <p className="flex gap-2 items-center">
                          <ServiceSVG />
                          <span className="capitalize">
                            {pkg?.name[currentLang]}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              )
            )}
          </div>

          <div>
            <p>
              {" "}
              {intl.formatMessage({
                id: "packagesByMember",
              })}
            </p>
            {teamMemberData?.packages?.map(
              (pkg: {
                id: number;
                name: { ar: string; en: string };
                total_time: string;
                retail_price: string;
              }) => (
                <>
                  <div
                    key={pkg?.id}
                    className="flex px-2 gap-2 my-1 bg-white p-1 justify-between rounded"
                  >
                    <div className="flex items-center  w-full ">
                      <div className="flex gap-8 items-center justify-between w-full p-1">
                        <p className="flex gap-2 items-center">
                          <PackagesSVG />
                          <span className="capitalize">
                            {pkg?.name[currentLang]}
                          </span>
                        </p>
                        <p className="flex gap-1 items-center ">
                          <span>{pkg?.total_time}</span>
                          <small className="text-xs self-center mt-2">
                            {" "}
                            {intl.formatMessage({
                              id: "minutes",
                              defaultMessage: "دقيقة",
                            })}
                          </small>
                        </p>
                        <p className="flex gap-1 items-center ">
                          <span>{pkg?.retail_price}</span>
                          <small className="text-xs self-center mt-2">
                            {intl.formatMessage({
                              id: "SAR",
                              defaultMessage: "ريال سعودي",
                            })}
                          </small>
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              )
            )}
          </div>
        </div>
      )}

      {editing && (
        <div className="mt-7">
          {showServiceSelector && (
            <Form
              layout="vertical"
              onFinish={onFinish}
              initialValues={{
                services: [""],
                packages: [""],
              }}
              form={form}
            >
              <Form.List name="services">
                {(fields, { add, remove }) => (
                  <>
                    <Form.Item className="p-2 rounded bg-color-light-gr w-full text-color-primary">
                      <div>
                        <Row className="mb-4">
                          <Col
                            className="gutter-row"
                            xl={24}
                            lg={8}
                            xs={24}
                            sm={24}
                            span={11}
                          >
                            <label className="text-color-primary">
                              {intl.formatMessage({
                                id: "servicesByMember",
                                defaultMessage: "الخدمات المقدمة من العضو",
                              })}
                            </label>
                          </Col>
                        </Row>

                        {fields.map(({ key, name, ...restField }, index) => (
                          <Row
                            key={key}
                            gutter={{ xs: 8, sm: 16, md: 24, lg: 15 }}
                          >
                            <Col
                              className="gutter-row"
                              xl={11}
                              lg={11}
                              xs={22}
                              sm={10}
                              span={10}
                            >
                              <Form.Item
                                {...restField}
                                required={false}
                                label={intl.formatMessage({
                                  id: "service_category_label",
                                })}
                                rules={[
                                  {
                                    required: true,
                                    message: intl.formatMessage({
                                      id: "service_category_required_message",
                                    }),
                                  },
                                ]}
                              >
                                <Select
                                  placeholder={intl.formatMessage({
                                    id: "service_category_placeholder",
                                  })}
                                  className="w-full my-input"
                                  options={listCategories?.data?.map(
                                    (item: Category) => ({
                                      value: item?.id,
                                      label: (
                                        <span className="capitalize">
                                          {item?.name}
                                        </span>
                                      ),
                                    })
                                  )}
                                  onChange={(value) => {
                                    console.log(value);
                                    setSelectedCategoryId(value);
                                  }}
                                />
                              </Form.Item>
                            </Col>

                            <Col
                              className="gutter-row"
                              xl={11}
                              lg={11}
                              xs={22}
                              sm={10}
                              span={10}
                            >
                              <Form.Item
                                {...restField}
                                required={false}
                                name={["services"]}
                                label={intl.formatMessage({
                                  id: "service",
                                  description: " الخدمة",
                                })}
                                // rules={[{ required: true, message: "اختر الخدمة " }]}
                              >
                                <Select
                                  placeholder={intl.formatMessage({
                                    id: "selectService",
                                    description: "اختر الخدمة",
                                  })}
                                  options={
                                    listServices?.data &&
                                    listServices.data.map(
                                      (service: service) => {
                                        return {
                                          value: service.id,
                                          label: (
                                            <span className="capitalize">
                                              {service?.name}
                                            </span>
                                          ),
                                          key: service?.id,
                                          disabled: !!selectedServices?.find(
                                            (item) => item?.id === service?.id
                                          ),
                                        };
                                      }
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col
                              className="gutter-row"
                              xl={2}
                              lg={2}
                              xs={2}
                              sm={4}
                              span={2}
                            >
                              <Form.Item label=" ">
                                <Button
                                  className="border-none bg-transparent shadow-none outline-none"
                                  onClick={() => {
                                    const selectedServiceId =
                                      form.getFieldValue(["services"])[
                                        "services"
                                      ];
                                    if (!selectedServiceId) {
                                      return false;
                                    }
                                    const existedService =
                                      selectedServices?.find(
                                        (service) =>
                                          service?.id ===
                                          parseInt(selectedServiceId)
                                      );
                                    if (existedService) return;
                                    const service: service | undefined =
                                      listServices?.data?.find(
                                        (service: service) =>
                                          service?.id ===
                                          parseInt(selectedServiceId)
                                      );
                                    if (!service) return;
                                    setSelectedServices([
                                      ...selectedServices,
                                      {
                                        id: parseInt(selectedServiceId),
                                        name: service?.name,
                                      },
                                    ]);
                                    form.resetFields(["services", index]);
                                  }}
                                  block
                                  icon={
                                    <PlusOutlined className="bg-[#00086D] text-white p-1 rounded-md" />
                                  }
                                ></Button>
                              </Form.Item>
                            </Col>
                          </Row>
                        ))}
                        <div>
                          {selectedServices.map((service) => (
                            <>
                              <div
                                key={service?.id}
                                className="flex px-2 gap-2 my-1 bg-white p-1 justify-between rounded"
                              >
                                <div className="flex items-center ">
                                  <div className="flex gap-1 items-center">
                                    <span>
                                      <IconSVG />
                                    </span>
                                    <span className="capitalize">
                                      {service?.name}
                                    </span>
                                  </div>
                                </div>

                                <Button
                                  type="text"
                                  htmlType="button"
                                  onClick={() =>
                                    handleRemoveService(service.id)
                                  }
                                >
                                  <DeleteSVG />
                                </Button>
                              </div>
                            </>
                          ))}
                        </div>
                      </div>
                    </Form.Item>
                  </>
                )}
              </Form.List>

              <Form.List name="packages">
                {(fields, { add, remove }) => (
                  <>
                    <Form.Item className="p-2 rounded bg-color-light-gr w-full text-color-primary">
                      <div>
                        <Row className="mb-4">
                          <Col
                            className="gutter-row"
                            xl={24}
                            lg={8}
                            xs={24}
                            sm={24}
                            span={11}
                          >
                            <label className="text-color-primary">
                              {intl.formatMessage({
                                id: "packagesByMember",
                              })}
                            </label>
                          </Col>
                        </Row>

                        {fields.map(({ key, name, ...restField }, index) => (
                          <Row
                            key={key}
                            gutter={{ xs: 8, sm: 16, md: 24, lg: 15 }}
                          >
                            <Col
                              className="gutter-row"
                              xl={11}
                              lg={11}
                              xs={22}
                              sm={10}
                              span={10}
                            >
                              <Form.Item
                                {...restField}
                                required={false}
                                label={intl.formatMessage({
                                  id: "package_category_label",
                                })}
                                rules={[
                                  {
                                    required: true,
                                    message: intl.formatMessage({
                                      id: "package_category_required_message",
                                    }),
                                  },
                                ]}
                              >
                                <Select
                                  placeholder={intl.formatMessage({
                                    id: "package_category_placeholder",
                                  })}
                                  className="w-full my-input"
                                  options={packagesCategoriesOptions}
                                  onChange={(value) => {
                                    setSelectedPackageCategoryId(value);
                                  }}
                                />
                              </Form.Item>
                            </Col>

                            <Col
                              className="gutter-row"
                              xl={11}
                              lg={11}
                              xs={22}
                              sm={10}
                              span={10}
                            >
                              <Form.Item
                                {...restField}
                                required={false}
                                name={["packages"]}
                                label={intl.formatMessage({
                                  id: "package",
                                })}
                                // rules={[{ required: true, message: "اختر الخدمة " }]}
                              >
                                <Select
                                  placeholder={intl.formatMessage({
                                    id: "select_package",
                                  })}
                                  options={getPackagesOptions()}
                                />
                              </Form.Item>
                            </Col>
                            <Col
                              className="gutter-row"
                              xl={2}
                              lg={2}
                              xs={2}
                              sm={4}
                              span={2}
                            >
                              <Form.Item label=" ">
                                <Button
                                  className="border-none bg-transparent shadow-none outline-none"
                                  onClick={() => {
                                    const selectedPackageId =
                                      form.getFieldValue(["packages"])[
                                        "packages"
                                      ];
                                    if (!selectedPackageId) {
                                      return false;
                                    }
                                    const existedPackage =
                                      selectedPackages?.find(
                                        (pkg) =>
                                          pkg?.id ===
                                          parseInt(selectedPackageId)
                                      );
                                    if (existedPackage) return;
                                    const categoryPackages = packages?.find(
                                      (pkg: {
                                        id: number;
                                        name: string;
                                        packages: Array<{
                                          name: string;
                                          id: number;
                                          total_time: string;
                                          retail_price: string;
                                        }>;
                                      }) =>
                                        pkg?.id === selectedPackageCategoryId
                                    );
                                    if (!categoryPackages) return;

                                    const newPackage =
                                      categoryPackages?.packages?.find(
                                        (service: {
                                          id: number;
                                          name: string;
                                          total_time: string;
                                          price: string;
                                        }) =>
                                          service?.id ===
                                          parseInt(selectedPackageId)
                                      );
                                    if (!newPackage) return;
                                    setSelectedPackages([
                                      ...selectedPackages,
                                      {
                                        id: newPackage?.id,
                                        name: newPackage?.name,
                                        total_time: newPackage?.total_time,
                                        retail_price: newPackage?.retail_price,
                                      },
                                    ]);
                                    form.resetFields(["packages", index]);
                                  }}
                                  block
                                  icon={
                                    <PlusOutlined className="bg-[#00086D] text-white p-1 rounded-md" />
                                  }
                                ></Button>
                              </Form.Item>
                            </Col>
                          </Row>
                        ))}
                        <div>
                          {selectedPackages.map((pkg) => (
                            <div
                              key={pkg?.id}
                              className="flex px-2 gap-2 my-1 bg-white p-1 justify-between rounded"
                            >
                              <div className="grid grid-cols-3 w-full gap-8 items-center">
                                <p className="flex gap-2 items-center">
                                  <IconSVG />
                                  <span className="capitalize">{pkg.name}</span>
                                </p>
                                <SubInfo
                                  label={intl.formatMessage({
                                    id: "minutes",
                                  })}
                                  value={pkg?.total_time}
                                />

                                <SubInfo
                                  label={intl.formatMessage({
                                    id: "SAR",
                                  })}
                                  value={pkg?.retail_price}
                                />
                              </div>

                              <Button
                                type="text"
                                htmlType="button"
                                onClick={() => {
                                  const newPackages = selectedPackages.filter(
                                    (p) => p?.id !== pkg?.id
                                  );
                                  setSelectedPackages(newPackages);
                                }}
                              >
                                <DeleteSVG />
                              </Button>
                            </div>
                          ))}
                        </div>
                      </div>
                    </Form.Item>
                  </>
                )}
              </Form.List>
              <Flex gap="small" justify="flex-end">
                <Button
                  type="primary"
                  loading={isLoading}
                  className="text-white w-[164.5px]"
                  htmlType="submit"
                >
                  {intl.formatMessage({
                    id: "saveChanges",
                    defaultMessage: "حفظ التغييرات",
                  })}{" "}
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    setEditing(!editing);
                    setShowServiceSelector(false);
                  }}
                  className="bg-color-light text-black w-[164.5px]"
                  htmlType="button"
                >
                  {intl.formatMessage({
                    id: "cancel",
                    defaultMessage: "إلفاء",
                  })}
                </Button>
              </Flex>
            </Form>
          )}
          {!showServiceSelector && (
            <Flex gap="small" justify="flex-start ">
              <Button
                type="primary"
                className="h-full mt-7 bg-transparent text-[#00086D] border-[#00086D]"
                icon={<PlusSquareOutlined />}
                onClick={handleAddLocationClick}
              >
                {intl.formatMessage({
                  id: "addNewService",
                  defaultMessage: "اضف خدمة جديدة",
                })}
              </Button>
            </Flex>
          )}
        </div>
      )}
    </div>
  );
};

export default ServiceInfo;
